import React, {useEffect, useState} from "react";
import OrderMap from "./OrderMap";
import RestRequest from "../../tools/RestRequest";
import config from "../../config";

export default function OrderCheckout() {

    const [addr, setAddr] = useState('');
    const [deliveries, setDeliveries] = useState([]);

    useEffect(() => {
        RestRequest.all(`${config.restDelivery}?filter[active]=1`).then(data => {
            setDeliveries(data);
        });
    }, []);

    let handleSelectPayment = (e) => {
        let value = parseInt(e.target.value);
    };

    let handleSelectDelivery = (e) => {
        let value = parseInt(e.target.value);
    };

    let selectAddr = (stringAddress) => {
        setAddr(stringAddress);
    };

    return <div className="order-checkout">
        <div className="order-checkout-row">
            <div className="order-checkout-col">
                <select name="delivery_id" onChange={handleSelectDelivery}>
                    <option value="">Выбрать доставку</option>

                    {deliveries.map((el, index) => {
                        return <option key={index} value={el.id}>{el.name}</option>
                    })}
                </select>
            </div>

            <div className="order-checkout-col">
                <select name="delivery_id" onChange={handleSelectPayment}>
                    <option value="1">Доставка по городу</option>
                    <option value="2">Самовывоз</option>
                </select>
            </div>
        </div>

        <input type="text" value={addr}/>

        <OrderMap
            useDefaultLocation={true}
            events={{
                'onClickMap': selectAddr,
            }}
        />

    </div>;
}

